import React from "react";
import AdminHome from "../../components/AdminHome/AdminHome";
import Footer from "../../common/Footer/Footer";
import UserPage from "../../common/UserPage/UserPage";


const AdminHomePage = () => {
  return (
    <div>
      <UserPage />      
      <AdminHome />
      <Footer />
    </div>
  );
};

export default AdminHomePage;
